import { render, staticRenderFns } from "./UnitAttachToParentForm.vue?vue&type=template&id=b9ab3be4&scoped=true&"
import script from "./UnitAttachToParentForm.vue?vue&type=script&lang=js&"
export * from "./UnitAttachToParentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ab3be4",
  null
  
)

export default component.exports